package com.sddamico.swigmore.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeDisplay
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** [OnCream]: green tiles with gold labels (inside the ballot card). [OnField]: cream tiles (ballot page header). */
enum class CountdownTone { OnCream, OnField }

/** DAY / HR / MIN / SEC split of a non-negative millisecond duration, zero-padded. */
fun countdownParts(remainingMs: Long): List<Pair<String, String>> {
  var ms = remainingMs.coerceAtLeast(0)
  return listOf("Day" to 86_400_000L, "Hr" to 3_600_000L, "Min" to 60_000L, "Sec" to 1_000L).map { (label, unit) ->
    val v = ms / unit
    ms -= v * unit
    label to v.toString().padStart(2, '0')
  }
}

/** Four-tile countdown to the ballot deadline. Drive [remainingMs] from a ticking clock. */
@Composable
fun Countdown(remainingMs: Long, modifier: Modifier = Modifier, tone: CountdownTone = CountdownTone.OnCream) {
  Div(
    attrs = Modifier
      .css(
        "display" to if (tone == CountdownTone.OnCream) "grid" else "flex",
        "grid-template-columns" to "repeat(4,minmax(0,1fr))",
        "gap" to "6px",
      )
      .then(modifier)
      .toAttrs { attr("role", "timer") }
  ) {
    countdownParts(remainingMs).forEach { (label, value) ->
      Div(
        attrs = Modifier
          .css("border-radius" to SwEffects.radiusSm, "text-align" to "center", "padding" to "7px 0 5px")
          .then(
            if (tone == CountdownTone.OnCream) Modifier.css("background" to SwColor.field700, "color" to SwColor.cream)
            else Modifier.css("background" to SwColor.cream, "color" to SwColor.field700, "width" to "58px")
          )
          .toAttrs()
      ) {
        Div(attrs = Modifier.typeDisplay("24px").toAttrs()) { Text(value) }
        Div(
          attrs = Modifier.typeCaps("8px", ".14em")
            .css("margin-top" to "4px")
            .then(if (tone == CountdownTone.OnCream) Modifier.css("color" to SwColor.gold) else Modifier)
            .toAttrs()
        ) { Text(label) }
      }
    }
  }
}
